import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import "./docx.css"
import './fonts/gilroy/stylesheet.css';
import './fonts/museo-sans-display/stylesheet.css';
import App from './App';
import { PersistGate } from "redux-persist/integration/react";

import reportWebVitals from './reportWebVitals';

import { ThemeProvider } from "@mui/material";
import globalTheme from "./globalTheme";
import { Provider } from "react-redux";
import { store,persistor } from "./store/store";
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
// eslint-disable-next-line react/no-array-index-key

root.render(
  // <React.StrictMode>
   <Provider store={store}>
     <PersistGate loading={null} persistor={persistor}>
      <ThemeProvider theme={globalTheme}>
        <App />
      </ThemeProvider></PersistGate>
    </Provider>
  // </React.StrictMode>
);
reportWebVitals();
